export default __webpack_public_path__ + "static/media/animal.6983927b.svg";